export class ThermalSpareBill {

    static buildHtml(data: any, det: any[], branches: string[] = [], logo: string = ''): string {
        const h = data;
        const payment = (h.payment || '').toUpperCase();
        const showBank = payment === 'CARD' || payment === 'CHEQUE' || payment === 'ONLINE';
        const bankRow = (showBank && h.bank)
            ? `<div class="t-info-row"><span class="lbl">Bank</span><span class="sep">:</span><span class="val">${ThermalSpareBill.esc(h.bank)}</span></div>`
            : '';

        let itemRows = '';
        (det || []).forEach((i: any) => {
            const hsn    = i.hsn_name || '';
            const name   = i.machine_name || '';
            const serial = i.serial_no || '';
            const qty    = i.machine_qty || '';
            const rate   = i.rate || '';
            const amt    = i.free_item === 'Yes' ? '' : (i.machine_price || '');
            itemRows += `<tr>
                <td>${ThermalSpareBill.esc(hsn)}</td>
                <td class="tl">${ThermalSpareBill.esc(name)} - Serial No (${ThermalSpareBill.esc(serial)})</td>
                <td>${ThermalSpareBill.esc(String(qty))}</td>
                <td class="tr">${ThermalSpareBill.esc(String(rate))}</td>
                <td class="tr">${ThermalSpareBill.esc(String(amt))}</td>
            </tr>`;
        });

        const amount       = parseFloat(h.amount) || 0;
        const grossTotal   = parseFloat(String(h.gross_total || 0));
        const discount     = parseFloat(String(h.discount_amount || 0));
        let totalTax = 0;
        (det || []).forEach((item: any) => {
            if (item.free_item === 'Yes') { return; }
            totalTax += parseFloat(item.mrp || 0) * parseFloat(item.machine_qty || 0) * parseFloat(item.gstper || 0) / 100;
        });
        const cgstAmt      = (totalTax / 2).toFixed(2);
        const sgstAmt      = (totalTax / 2).toFixed(2);
        const grandTotal        = parseFloat((grossTotal + parseFloat(cgstAmt) + parseFloat(sgstAmt)).toFixed(2));
        const netAfterDiscount  = parseFloat((grandTotal - discount).toFixed(2));
        const roundOff          = parseFloat((Math.round(netAfterDiscount) - netAfterDiscount).toFixed(2));
        const finalTotal        = Math.round(netAfterDiscount);

        const phone   = h.phoneno || h.comp_mobile || '';
        const email   = h.comp_email || '';
        const tollFree = h.toll_free || '1800 270 1996';

        const compEmail = 'hello@soundsgood.in';
        const phoneEmailLine = phone
            ? `Ph: ${ThermalSpareBill.esc(phone)} | ${ThermalSpareBill.esc(compEmail)}`
            : ThermalSpareBill.esc(compEmail);

        const logoTag = logo
            ? `<div class="t-t-center"><img src="${logo}" height="55" alt="Sounds Good" style="filter:grayscale(100%);"></div>`
            : '';

        const branchText = branches.length > 0
            ? branches.join(', ')
            : '';

        return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<title>Spare Bill - ${ThermalSpareBill.esc(h.bill_no || '')}</title>
<style>
* { box-sizing: border-box; margin: 0; padding: 0; }
body { background: #fff; font-family: 'Courier New', Courier, monospace; font-size: 11px; color: #000; }
.thermal-wrap { width: 300px; padding: 10px 10px 16px 10px; }
.t-t-center { text-align: center; }
.t-bold { font-weight: bold; }
.t-div-solid { border-top: 1px solid #000; margin: 5px 0; }
.t-div-dash { border-top: 1px dashed #000; margin: 5px 0; }
.t-info-row { display: flex; font-size: 11px; margin: 1px 0; }
.t-info-row .lbl { min-width: 72px; font-weight: bold; }
.t-info-row .sep { width: 12px; }
.t-info-row .val { flex: 1; }
.t-items-table { width: 100%; border-collapse: collapse; font-size: 10px; margin: 4px 0; }
.t-items-table th { border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: center; font-size: 10px; }
.t-items-table th.tl { text-align: left; }
.t-items-table td { padding: 2px; vertical-align: top; text-align: center; }
.t-items-table td.tl { text-align: left; word-break: break-word; }
.t-items-table td.tr { text-align: right; }
.t-total-row { display: flex; justify-content: space-between; font-size: 11px; padding: 1px 0; }
.t-total-row.grand { font-weight: bold; font-size: 13px; border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px 0; margin: 2px 0; }
.t-branch-box { border: 1px solid #000; border-radius: 4px; font-size: 9px; text-align: center; padding: 5px 6px; line-height: 1.6; margin: 5px 0; }
.t-toll-bar { display: flex; align-items: center; justify-content: center; gap: 6px; border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 4px 0; margin: 4px 0; }
.t-toll-bar .tt { font-size: 9px; font-family: Arial, sans-serif; }
.t-toll-bar .tn { font-size: 14px; font-weight: bold; font-family: Arial, sans-serif; }
</style>
</head>
<body>
<div class="thermal-wrap">
  ${logoTag}
  <div class="t-t-center t-bold" style="font-size:13px;font-family:Arial,sans-serif;font-style:italic;margin-top:2px;">HERO ELECTRONIC</div>
  <div class="t-t-center" style="font-size:10px;margin-top:2px;">${ThermalSpareBill.esc(h.comp_address || '')}</div>
  ${phoneEmailLine ? `<div class="t-t-center" style="font-size:10px;">${phoneEmailLine}</div>` : ''}
  <div class="t-t-center" style="font-size:10px;">www.soundsgood.in</div>
  <div class="t-div-solid"></div>
  <div class="t-t-center t-bold" style="font-size:12px;margin:3px 0;">SPARE BILL</div>
  <div class="t-div-solid"></div>
  <div class="t-info-row"><span class="lbl">GST No</span><span class="sep">:</span><span class="val">${ThermalSpareBill.esc(h.tinno || '')}</span></div>
  <div class="t-info-row"><span class="lbl">Bill No</span><span class="sep">:</span><span class="val">${ThermalSpareBill.esc(h.bill_no || '')}</span></div>
  <div class="t-info-row"><span class="lbl">Bill Date</span><span class="sep">:</span><span class="val">${ThermalSpareBill.esc(h.disp_date || '')}</span></div>
  <div class="t-info-row"><span class="lbl">Bill Type</span><span class="sep">:</span><span class="val">${ThermalSpareBill.esc(payment)}</span></div>
  ${bankRow}
  <div class="t-div-dash"></div>
  <div class="t-info-row"><span class="lbl">To Mr/Mrs</span><span class="sep">:</span><span class="val">${ThermalSpareBill.esc(h.client_name || '')}</span></div>
  <div class="t-info-row"><span class="lbl">Address</span><span class="sep">:</span><span class="val">${ThermalSpareBill.esc(h.address || '')}</span></div>
  <div class="t-info-row"><span class="lbl">Mobile No</span><span class="sep">:</span><span class="val">${ThermalSpareBill.esc(h.mobile || '')}</span></div>
  <div class="t-info-row"><span class="lbl">Client ID</span><span class="sep">:</span><span class="val">${ThermalSpareBill.esc(h.client_no || '')}</span></div>
  <div class="t-div-solid"></div>
  <table class="t-items-table">
    <thead>
      <tr>
        <th style="width:10%">HSN</th>
        <th class="tl" style="width:40%">PARTICULARS</th>
        <th style="width:8%">QTY</th>
        <th style="width:14%">RATE</th>
        <th style="width:14%">AMT</th>
      </tr>
    </thead>
    <tbody>
      ${itemRows}
    </tbody>
  </table>
  <div class="t-div-dash"></div>
  <div class="t-total-row"><span>Gross Total</span><span>${ThermalSpareBill.esc(String(grossTotal))}</span></div>
  <div class="t-total-row"><span>CGST @ 9%</span><span>${cgstAmt}</span></div>
  <div class="t-total-row"><span>SGST @ 9%</span><span>${sgstAmt}</span></div>
  <div class="t-total-row grand"><span>Grand Total</span><span>${ThermalSpareBill.esc(String(grandTotal))}</span></div>
  <div class="t-total-row"><span>Discount Amount</span><span>${ThermalSpareBill.esc(String(discount))}</span></div>
  <div class="t-total-row"><span>Round Off</span><span>${roundOff >= 0 ? '+' : ''}${ThermalSpareBill.esc(String(roundOff))}</span></div>
  <div class="t-total-row grand"><span>Total</span><span>Rs. ${ThermalSpareBill.esc(finalTotal.toFixed(2))}</span></div>
  <div class="t-div-dash"></div>
  <div class="t-t-center t-bold" style="font-size:10px;font-family:Arial,sans-serif;margin:3px 0;">Our Branches</div>
  <div class="t-branch-box">${ThermalSpareBill.esc(branchText)}</div>
  <div class="t-toll-bar">
    <span class="tt">&#x260E; Toll Free :</span>
    <span class="tn">${ThermalSpareBill.esc(tollFree)}</span>
  </div>
  <div class="t-t-center" style="font-size:9px;margin-top:4px;">Software By: Symatis Solutions</div>
  <div class="t-t-center" style="font-size:9px;">www.symatis.com</div>
</div>
</body>
</html>`;
    }

    static esc(str: string): string {
        if (str == null) { return ''; }
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/shared/print/thermal.spare.bill.ts